<template>
  <div :class="this.$route.name === 'home' ? '' : 'flex flex-col h-full'">
    <branded-header :href="$router.currentRoute.meta.headerHref" />
    <a
      id="focusResetAnchor"
      tabindex="-1"
      class="hidden"
      href="https://flightvoucher.com"
    >Focus reset</a>

    <router-view />

    <branded-footer v-if="!$router.currentRoute.meta.hideFooter" />
  </div>
</template>

<script>
import BrandedHeader from '~brand-components/brussels/shared/header.vue'
import BrandedFooter from '~brand-components/brussels/shared/footer.vue'

export default {
  components: {
    BrandedHeader,
    BrandedFooter,
  },
}
</script>
